import { ASYNC_TASK_MAP, ASYNC_TASK_TYPE, ERROR_CODE } from '@/config/asyncTask'
import CONFIG from '@/config'
export default {
  data() {
    return {
      CONFIG,
      ASYNC_TASK_MAP,
      ASYNC_TASK_TYPE,
      ERROR_CODE,
      visible: false,
      task: null,
      role: this.$store.state.user.user_info.role
    }
  },
  props: {
    isSync: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  computed: {
    taskSubTitle() {
      if (!this.task) return ''
      console.log('task', this.task)
      switch (this.task.type) {
        default:
          return this.$t(ASYNC_TASK_MAP[this.task.type].error, [
            this.task.total - this.task.unfinished,
            this.task.unfinished
          ])
      }
    }
  },
  methods: {
    setResultData(data) {
      this.task = JSON.parse(JSON.stringify(data))
      console.log('set task', this.task)
      if (data.type === 13) {
        const hasImgErr = data?.error_data?.data?.some(i => i.code == 3109)
        const hasNetErr = data?.error_data?.data?.some(i => i.code == 3100)
        if (hasImgErr) {
          this.$log.trace('show_copy_cardholder_fail_reason', { type: 2 })
        }
        if (hasNetErr) {
          this.$log.trace('show_copy_cardholder_fail_reason', { type: 4 })
        }
        if (!hasImgErr && !hasNetErr) {
          this.$log.trace('show_copy_cardholder_fail_reason', { type: 1 })
        }
      }
    },
    closeModal() {
      this.visible = false
      this.$nextTick(() => {
        this.task = null
      })
    }
  }
}
